(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["process-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  if (typeof Swiper !== "undefined") {
    const swiper = new Swiper('.process-slider', {
      slidesPerView: 1,
      spaceBetween: 30,
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      on: {
        progress: function() {
          for (let i = 0; i < this.slides.length; i++) {
            const slide = this.slides[i];
            const slideIndex = slide.getAttribute("data-swiper-slide-index");
            const relativeIndex = (slideIndex - this.realIndex + this.slides.length) % this.slides.length;

            let scale, zIndex;
            if (relativeIndex === 0) {
              scale = 1.0;
              zIndex = 5; // always in front
            } else if (relativeIndex === 1) {
              scale = 0.9;
              zIndex = 4;
            } else if (relativeIndex === 2) {
              scale = 0.85;
              zIndex = 3;
            } else if (relativeIndex === 3) {
              scale = 0.8;
              zIndex = 2;
            } else {
              scale = 0.75;
              zIndex = 1;
            }

            slide.style.transform = `scale(${scale})`;
            slide.style.zIndex = zIndex;
            slide.style.opacity = 1; // keep them visible
          }
        },
        setTransition: function(speed) {
          for (let i = 0; i < this.slides.length; i++) {
            this.slides[i].style.transition = speed + 'ms';
          }
        }
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-slider"] && !Shopify.designMode) return;
  try {
    
var swiper = new Swiper('.testimonial-wrapper', {
  loop: true,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  }
});

  } catch(e) { console.error(e); }
})();
})();
